import { createContext } from 'react';

export interface SelectionContextType<RecordType> {
    selection: RecordType;
    setSelection: (select: RecordType) => void;
}

export default createContext<SelectionContextType<any>>(undefined as any);
